import React, { useRef, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppStoreGroupApplication } from "@/services/AppStore";
import { IconAddApp } from "@/components/icon";
import AppItem from "@/components/ThirdApp/components/RightContent/AppItem";
import Loading from "@/components/Loading";
import { favoriteGroupId, RECENT_GRROUP_ID } from "@/components/ThirdApp";
import { isBjme } from "@/utils";
import "./index.less";
import ScrollView from "@/baseComponents/ScrollView";
import NewVersionGuide from "./NewVersionGuide";
import colors from "@/components/styles/colors";
import notFoundUrl from "@/assets/img/thirdApp/icon-not-found.png";
import notFoundNetwork from "@/assets/img/thirdApp/icon-not-network.png";
import { ThirdAppContext, FavoviteSortType } from "@/components/ThirdApp/utils";
import DropdownSort from "./DropdownSort";

const Label = ({ name }: { name: string }) => (
  <div className="third-content-item_title">{name}</div>
);

export default function Content ({
  groups,
  loading,
  moreHidden
}: {
  groups: AppStoreGroupApplication[];
  loading: boolean;
  moreHidden?: boolean;
}) {
  const { t } = useTranslation("common");
  const { isOnline, favoriteSortType } = useContext(ThirdAppContext);
  const scrollRef: any = useRef(null);
  const groupIds = groups.map((item) => item.groupId);
  const Group = ({ group }: { group: AppStoreGroupApplication }) => (
    <div style={{ marginBottom: 10 }}>
      <div
        id={group.groupId === RECENT_GRROUP_ID ? "常用应用" : group.name}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "20px"
        }}
      >
        <Label name={group.groupId === RECENT_GRROUP_ID ? "常用应用" : group.name} />
        {group.groupId === favoriteGroupId || group.groupId === RECENT_GRROUP_ID ? (
          <DropdownSort />
        ) : (
          ""
        )}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {group.applications.map((item, index) => (
          <AppItem key={index} appInfo={item} moreHidden={moreHidden} />
        ))}
      </div>
    </div>
  );
  return (
    <div className="third-right-content">
      <NewVersionGuide />
      <ScrollView ref={scrollRef} autoHide id="content_scroll_id">
        {!loading &&
          groups.length > 0 &&
          groups.map((group, i) => {
            let curGroup = group;
            if (favoriteSortType === FavoviteSortType.BySort) {
              if (group.groupId === RECENT_GRROUP_ID) {
                curGroup = groups[groupIds.indexOf(RECENT_GRROUP_ID)];
                // curGroup.name = "常用应用";
              } else if (group.groupId === favoriteGroupId) {
                return "";
              }
            } else if (favoriteSortType === FavoviteSortType.Favorite) {
              if (group.groupId === favoriteGroupId) {
                curGroup = groups[groupIds.indexOf(favoriteGroupId)];
              } else if (group.groupId === RECENT_GRROUP_ID) {
                return "";
              }
            }
            return <Group group={curGroup} key={i} />;
          })}
        {/* no-data */}
        {!loading && groups.length === 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%"
            }}
          >
            <div>
              <img src={isOnline ? notFoundUrl : notFoundNetwork} style={{ width: "200px" }} />
              <div style={{ textAlign: "center" }}>
                {isOnline ? "暂无数据" : "应用找不到了，请检查网络链接"}
              </div>
            </div>
          </div>
        )}
        {/* 提示 */}
        {/* {!loading && groups.length > 0 && (
          <p
            style={{
              fontSize: "12px",
              color: "#8F959E",
              textAlign: "center",
              marginBottom: 20
            }}
          >
            说明：浅蓝色为部署在政务云上的工具、浅黄色为部署在非政务云上的工具
          </p>
        )} */}
        {/* loading中 */}
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%"
            }}
          >
            <Loading />
          </div>
        )}
      </ScrollView>
    </div>
  );
}
